import { useEffect } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#business`,
  name: 'LevelPro Solutions Inc',
  image: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/e8a463460a8c4c4f05ea72f0c7b7543f.png',
  logo: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/e8a463460a8c4c4f05ea72f0c7b7543f.png',
  description:
    'Professional concrete leveling, slab jacking, basement waterproofing, and foundation crack repair services across Windsor, Essex, Belle River, Amherstburg, Kingsville, Leamington, and Tilbury.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Windsor',
    addressRegion: 'ON',
    addressCountry: 'CA',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 42.317432,
    longitude: -83.026772,
  },
  telephone: '+15199038995',
  email: 'Levelprosolution@gmail.com',
  url: SITE_URL,
  priceRange: '$$',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '17:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '08:00',
      closes: '14:00',
    },
  ],
  areaServed: [
    { '@type': 'City', name: 'Windsor', containedInPlace: { '@type': 'State', name: 'Ontario' } },
    { '@type': 'City', name: 'Essex', containedInPlace: { '@type': 'State', name: 'Ontario' } },
    { '@type': 'City', name: 'Belle River', containedInPlace: { '@type': 'State', name: 'Ontario' } },
    { '@type': 'City', name: 'Amherstburg', containedInPlace: { '@type': 'State', name: 'Ontario' } },
    { '@type': 'City', name: 'Kingsville', containedInPlace: { '@type': 'State', name: 'Ontario' } },
    { '@type': 'City', name: 'Leamington', containedInPlace: { '@type': 'State', name: 'Ontario' } },
    { '@type': 'City', name: 'Tilbury', containedInPlace: { '@type': 'State', name: 'Ontario' } },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Foundation & Concrete Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Concrete Slab Jacking and Leveling',
          description:
            'Polyurethane foam injection lifts and stabilizes sunken concrete driveways, patios, sidewalks, and garage floors across Windsor Essex County.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Basement Waterproofing',
          description:
            'Complete interior and exterior drainage systems, sump pump installation, and vapor barriers to keep your basement dry year-round.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Foundation Crack Repair',
          description:
            'Expert epoxy and polyurethane injection for structural and non-structural cracks, restoring your foundation\'s integrity.',
        },
      },
    ],
  },
  sameAs: [],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${SITE_URL}/#webpage`,
  url: SITE_URL,
  name: 'Windsor Essex Concrete Leveling & Basement Waterproofing | LevelPro Solutions Inc',
  description:
    'LevelPro Solutions Inc offers professional concrete leveling, slab jacking, basement waterproofing, and foundation crack repair in Windsor, Essex, Belle River, Amherstburg, Kingsville, Leamington & Tilbury.',
  isPartOf: { '@id': `${SITE_URL}/#website` },
  about: { '@id': `${SITE_URL}/#business` },
  inLanguage: 'en-CA',
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'LevelPro Solutions Inc',
  description: 'Professional concrete leveling and basement waterproofing across Windsor Essex County.',
  inLanguage: 'en-CA',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is concrete slab jacking?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Concrete slab jacking is a process that uses polyurethane foam injection to lift and level sunken concrete slabs. It\'s a fast, clean, and permanent solution for driveways, patios, sidewalks, and garage floors across Windsor and Essex County.',
      },
    },
    {
      '@type': 'Question',
      name: 'How long does basement waterproofing last?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Professional basement waterproofing systems installed by LevelPro Solutions are backed by our lifetime warranty and designed to protect your basement for decades when properly maintained.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do you offer free estimates?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, we provide free, no-obligation inspections and estimates for all our services including concrete leveling, basement waterproofing, and foundation crack repair across Windsor, Essex, Belle River, Amherstburg, Kingsville, Leamington, and Tilbury.',
      },
    },
    {
      '@type': 'Question',
      name: 'What areas do you serve?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'LevelPro Solutions Inc serves Windsor, Essex, Belle River, Amherstburg, Kingsville, Leamington, and Tilbury in Ontario, Canada.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are your business hours?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We are open Monday through Friday from 8:00 AM to 5:00 PM, and Saturday from 8:00 AM to 2:00 PM. We are closed on Sundays.',
      },
    },
  ],
};

const schemas = [localBusinessSchema, webPageSchema, websiteSchema, faqSchema];

export default function SeoJsonLd() {
  useEffect(() => {
    schemas.forEach((schema, i) => {
      const id = `ld-json-${i}`;
      let el = document.getElementById(id) as HTMLScriptElement | null;
      if (!el) {
        el = document.createElement('script');
        el.id = id;
        el.type = 'application/ld+json';
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(schema);
    });

    return () => {
      schemas.forEach((_, i) => {
        const el = document.getElementById(`ld-json-${i}`);
        if (el) el.remove();
      });
    };
  }, []);

  return null;
}
